<div *ngIf="isLoading" class="text-center py-5" role="status" aria-label="Loading bookings">
  <span class="spinner-border" aria-hidden="true"></span>
</div>
<div class="admin-bookings container" *ngIf="!isLoading">
  <div id="topContainer" class="row"
    style="display: flex; align-items: flex-start; flex-wrap: wrap; position: relative;">
    <!-- Service Selection -->
    <div class="col-md-4 col-sm-12 form-group" style="margin-top:10px;">
      <label class="fieldName" style="font-size:12px; display: block;">SERVICE</label>
      <div class="input-group">
        <select [(ngModel)]="selectedProductName" class="form-control" (change)="onProductChanged()">
          <option *ngFor="let product of products" [value]="product.name">
            {{product.name}}
          </option>
        </select>
      </div>
    </div>

    <!-- Date Selection -->
    <div class="col-md-3 col-sm-12 form-group" style="margin-top:10px;"
      *ngIf="selectedServiceType === 'Single Session'">
      <label class="fieldName" style="font-size:12px; display: block;">DATE</label>
      <div class="input-group">
        <input type="date" [(ngModel)]="selectedDateStr" class="form-control" placeholder="Select Date"
          value="{{selectedDateStr}}" name="selectedDate" (change)="onDateChange($event.target.value)">
      </div>
    </div>

    <!-- Start Date Selection -->
<!--  DO NOT DELETE : IT MIGHT BE REQUIRED IN THE FUTURE IF SESSIONS type product is implemented

      <div *ngIf="selectedServiceType === 'Multi Session'" class="col-md-3 col-sm-12 form-group" style="margin-top:10px;">
      <div *ngIf="sessionType === 'Sessions'">
        <label class="fieldName" style="font-size:12px; display: block;">SELECT THE SERVICE START DATE</label>
        <div class="input-group">
          <input type="date" [ngModel]="latest_date1 | date:'yyyy-MM-dd'" class="form-control" placeholder="yyyy-mm-dd"
            name="toDate" [min]="minDate" [max]="maxDate"
            (change)="onDateChange_MultiSessionSelectAnyDay($event.target.value)" (focus)="clearDate()">
        </div>
      </div>
    </div>-->

    <!-- Show Full Day Toggle and Book Now Button -->
    <div class="col-md-4 col-sm-12 form-group right-aligned-buttons">
      <div class="toggle-buttons">

        <mat-slide-toggle
          class="show-full-day-toggle"
          [(ngModel)]="showGroupVenueLayout"
          [ngModelOptions]="{standalone: true}"
          color="primary"
          *ngIf="selectedServiceType !== 'Multi Session' && !isAddOnSelected">

          <label class="fieldName toggle-label">
            Group Venues
          </label>

        </mat-slide-toggle>


        <mat-slide-toggle
          class="show-full-day-toggle"
          [(ngModel)]="showFullDay"
          [ngModelOptions]="{standalone: true}"
          color="primary"
          *ngIf="selectedServiceType !== 'Multi Session' && !isAddOnSelected">

          <label class="fieldName toggle-label">
            Show Full Day
          </label>

        </mat-slide-toggle>

      </div>

      <div
        class="booking-buttons"
        *ngIf="selectedServiceType !== 'Multi Session' && sessionType !== 'Flexible'">

        <button
          class="pop-up-btn-blue booking-btn"
          (click)="bookNow()">

          Book Now

        </button>

        <button
          class="pop-up-btn-blue booking-btn"
          *ngIf="selectedServiceType === 'Single Session'"
          (click)="openBulkBooking()">

          Bulk Booking

        </button>

      </div>
      <!--<button class="btn btn-primary book-now-btn" style="margin-top:20px;" (click)="bookNow()" *ngIf="selectedServiceType !== 'Multi Session'">Book Now</button>
      <button
        class=".pop-up-btn-blue"
        (click)="openBulkBooking()">

        Bulk Booking

      </button>-->
    </div>
  </div>

  <section class="addons-section" *ngIf="isAddOnSelected" aria-labelledby="admin-addon-heading">
    <h2 id="admin-addon-heading" class="addons-heading">Add-On</h2>
    <div class="addon-card">
      <h3 class="addon-name">{{ selectedProduct.name }}</h3>
      <div class="addon-price">Rs {{ selectedProduct.price | number:'1.2-2' }}/-</div>
      <p class="addon-description" *ngIf="selectedProduct.description">{{ selectedProduct.description }}</p>
      <div class="addon-actions">
        <div class="addon-quantity-field">
          <label class="addon-qty-label" for="admin-addon-qty">Qty</label>
          <div class="addon-quantity-controls">
            <button type="button" class="addon-quantity-step" aria-label="Decrease quantity" [disabled]="getAddOnQuantity() <= 1" (click)="changeAddOnQuantity(-1)">&minus;</button>
            <input id="admin-addon-qty" type="number" inputmode="numeric" class="form-control addon-qty" min="1" [max]="MAX_ADD_ON_QUANTITY" step="1" [ngModel]="getAddOnQuantity()" (ngModelChange)="addOnQuantities[selectedProduct.id] = $event; addOnError = ''" [attr.aria-invalid]="addOnError ? true : null" aria-describedby="admin-addon-error">
            <button type="button" class="addon-quantity-step" aria-label="Increase quantity" [disabled]="getAddOnQuantity() >= MAX_ADD_ON_QUANTITY" (click)="changeAddOnQuantity(1)">+</button>
          </div>
        </div>
        <button type="button" class="addon-submit" (click)="addSelectedAddOn()">{{ selectedAddOnsMap.has(selectedProduct.id) ? 'Update Cart' : 'Add to Cart' }}</button>
      </div>
      <p id="admin-addon-error" class="addon-error" role="alert" *ngIf="addOnError">{{ addOnError }}</p>
      <div class="addon-in-cart" *ngIf="selectedAddOnsMap.get(selectedProduct.id) as added">
        <span>Added: {{ added.quantity }} &times; Rs {{ added.unitPrice | number:'1.2-2' }}</span>
        <button type="button" class="addon-remove" (click)="removeSelectedAddOn()">Remove</button>
      </div>
    </div>
  </section>

  <div class="addon-cart-summary" *ngIf="isAddOnSelected && selectedAddOnsMap.size">
    <div><strong>Add-on cart: {{ selectedAddOnsMap.size }} item(s)</strong><span>Rs {{ addOnCartTotal | number:'1.2-2' }}</span></div>
  </div>
  <ng-container *ngIf="!isAddOnSelected">
  <!-- Booking Slots -->
  <div id="booking-slots"
    *ngIf="!showGroupVenueLayout && selectedDate && selectedProduct && venuesForSelectedProduct.length > 0   ">
    <mat-tab-group class="slotGrid" preserveContent>
      <mat-tab *ngFor="let venue of venuesForSelectedProduct">
        <ng-template mat-tab-label>
          <span style="text-transform: uppercase; font-size:12px;">{{ venue.name }}</span>
        </ng-template>

        <app-booking-slots [showFullDay]="showFullDay" [selectedDate]="selectedDate" [venueName]="venue.name"
          [selectedProduct]="selectedProduct">
        </app-booking-slots>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div *ngIf="(sessionType === 'Flexible' && !showFlexibleForm) || (selectedServiceType === 'Multi Session' && !showFlexibleForm )">
    <button class="btn btn-primary book-now-btn" style="margin-top: 10px;" (click)="showFlexiForm()">Book Now</button>
  </div>

  <div *ngIf="(getUniqueFormattedSortedTimeSlots().length && sessionType === 'Monthly' && showFlexibleForm)" >
    <label class="fieldName" style="font-size:12px; display: block; margin-top: 20px;">SELECT THE SERVICE START DATE</label>

    <div class="col-md-4 col-sm-12 form-group" style="margin-top:10px;"
         *ngIf="monthlyMultiBookingOption === 'Start Any Day'">
      <div class="input-group">
        <input type="date" [(ngModel)]="selectedDateStr" class="form-control" placeholder="Select Date"
               value="{{selectedDateStr}}" name="selectedDate" (change)="onMultiSessionServiceStartDateChange($event.target.value)">
      </div>
    </div>

    <div *ngIf="monthlyMultiBookingSelectedDates.length > 0 && monthlyMultiBookingOption === 'Selected Dates'">
      <form>
        <div *ngFor="let date of futureDates; let i = index" style="margin-bottom: 10px;">
          <label style="display: flex; align-items: center;">
            <input type="radio" name="startDate" [value]="date" [(ngModel)]="selectedStartDate"
                   (change)="onMultiSessionServiceStartDateChange(selectedStartDate)" [checked]="i === 0"
                   style="margin-left: 20px;">
            <span style="margin-left: 10px; font-size: 12px; font-weight: bold;">{{ date }}</span>
          </label>
        </div>
      </form>
    </div>


    <label class="fieldName" style="font-size:12px; display: block; margin-top: 30px;">SELECT TIME SLOT(S)</label>
    <div
      class="time-slot-grid">
      <label
        *ngFor="let time of getUniqueFormattedSortedTimeSlots()"
        class="fieldName"
        style="display:flex; align-items:center; font-size:13px; font-weight:normal; cursor:pointer;"
      >
        <input
          type="radio"
          name="selectedTime"
          [value]="time"
          (change)="onTimeRadioChange(time)"
          [checked]="selectedTime.includes(time)"
          style="margin-left:8px;"
        />
        <span style="margin-left:10px;">{{ time }}</span>
      </label>
    </div>

    <label class="fieldName" style="font-size:12px; display: block; margin-top: 30px;">SELECT A VENUE</label>
    <div *ngFor="let venue of venuesOfSelectedProduct">
      <label>
        <input
          type="radio"
          name="venueSelection"
          [value]="venue.id"
          [(ngModel)]="selectedVenueId"
          style="margin-left: 20px;"
        />
        <span style="margin-left: 10px;font-size:13px;">{{ venue.venueName }}</span>
      </label>
    </div>


    <button class="btn btn-primary book-now-btn" style="margin-top:20px;" (click)="bookNow()"
            [disabled]="!( (selectedDateStr || selectedStartDate) &&
                         selectedTime.length > 0 &&
                         selectedVenueId )">Book Now</button>
  </div>

  <div class="open-product-form" *ngIf="sessionType === 'Flexible' && showFlexibleForm">
    <form #formRef="ngForm" (ngSubmit)="bookNowOpenProduct(formRef)" novalidate>

      <!-- Row 1: Venue -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">Venue</label>
          <select [(ngModel)]="bookingData.venue" name="venue" required class="form-control">
            <option *ngFor="let venue of venues" [value]="venue.id">{{venue.name}}</option>
          </select>
        </div>
      </div>

      <!-- Row 2: Start Date + Number of Months -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">START DATE</label>
          <input type="date" name="startDate" [(ngModel)]="bookingData.startDate" (ngModelChange)="calculatePrice()" #startDate="ngModel" required class="form-control" placeholder="yyyy-mm-dd" />
          <div *ngIf="startDate.invalid && startDate.touched" class="text-danger">Start Date is required.</div>
        </div>

        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">NUMBER OF MONTHS</label>
          <select name="months" [(ngModel)]="bookingData.months" (ngModelChange)="calculatePrice()" #monthsCtrl="ngModel" required class="form-control">
            <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [ngValue]="m">{{ m }}</option>
          </select>
          <div *ngIf="monthsCtrl.invalid && monthsCtrl.touched" class="text-danger">Valid number of months is required.</div>
        </div>
      </div>

      <!-- Row 3: Days -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">DAYS</label>
          <mat-chip-listbox [(ngModel)]="bookingData.selectedDays" (ngModelChange)="calculatePrice()" name="selectedDays" #daysRef="ngModel" required multiple>
            <mat-chip-option *ngFor="let chip of productEditAddSessionChips" [value]="chip">{{ chip.charAt(0) }}</mat-chip-option>
          </mat-chip-listbox>
          <div *ngIf="formRef.submitted && daysRef.invalid" class="text-danger">Please select at least one day.</div>
        </div>
      </div>

      <!-- Row 4: Start Time + End Time -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">START TIME</label>
          <select [(ngModel)]="bookingData.startTime" name="startTime" (change)="updateEndTimeOption()" required class="form-control">
            <option [ngValue]="null">Select Start Time</option>
            <option *ngFor="let startTimeOption of startTimeOptions" [value]="startTimeOption">{{startTimeOption}}</option>
          </select>
        </div>

        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">END TIME</label>
          <select [(ngModel)]="bookingData.endTime" name="endTime" (change)="onEndTimeChange($event)" required class="form-control" [disabled]="!bookingData.startTime">
            <option [ngValue]="null">Select End Time</option>
            <option *ngFor="let endTimeOption of endTimeOptions" [ngValue]="endTimeOption">{{ endTimeOption }}</option>
          </select>
        </div>
      </div>

      <!-- Row 5: Total Amount -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">TOTAL AMOUNT</label>
          <input type="number" name="amount" [(ngModel)]="bookingData.amount" #amount="ngModel" required min="0.01" step="0.01" class="form-control" placeholder="Total Amount" />
          <div class="total-amt">
            ₹{{selectedProduct.price}} per session * {{totalSessions}} sessions = {{bookingData.amount}}
          </div>
          <div class="total-amt">
            Duration per session = {{selectedProduct.durationPerSlot}} minutes
          </div>
          <div *ngIf="amount.invalid && amount.touched" class="text-danger">
            <div *ngIf="amount.errors?.['required']">Amount is required.</div>
            <div *ngIf="amount.errors?.['min']">Amount must be greater than 0.</div>
          </div>
        </div>
      </div>

      <!-- Row 6: First Name + Last Name -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">FIRST NAME</label>
          <input type="text" name="firstName" [(ngModel)]="bookingData.firstName" #firstName="ngModel" required class="form-control" placeholder="First Name" />
          <div *ngIf="firstName.invalid && firstName.touched" class="text-danger">First Name is required.</div>
        </div>

        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">LAST NAME</label>
          <input type="text" name="lastName" [(ngModel)]="bookingData.lastName" #lastName="ngModel" required class="form-control" placeholder="Last Name" />
          <div *ngIf="lastName.invalid && lastName.touched" class="text-danger">Last Name is required.</div>
        </div>
      </div>

      <!-- Row 7: Email + Phone -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">EMAIL</label>
          <input type="email" name="email" [(ngModel)]="bookingData.email" #email="ngModel" required pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" class="form-control" placeholder="Email" />
          <div *ngIf="email.invalid && email.touched" class="text-danger">Valid Email is required.</div>
        </div>

        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">PHONE NUMBER</label>
          <input type="text" name="phone" [(ngModel)]="bookingData.phone" #phone="ngModel" required pattern="[0-9]{10}" class="form-control" placeholder="Phone Number" />
          <div *ngIf="phone.invalid && phone.touched" class="text-danger">Valid 10-digit Phone Number required.</div>
        </div>
      </div>

      <!-- Row 8: Notes -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">NOTES</label>
          <input type="text" name="notes" [(ngModel)]="bookingData.notes" class="form-control" placeholder="Notes" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">PAYMENT METHOD</label>
          <select [(ngModel)]="paymentMethod" name="paymentMethod" #paymentMethodCtrl="ngModel" required class="form-control">
            <option value="cash">Cash</option>
            <option value="payNow">Pay Now</option>
            <option value="sendLink">Send Payment Link</option>
          </select>
          <div *ngIf="paymentMethodCtrl.invalid && paymentMethodCtrl.touched" class="text-danger">
            Please select a payment method.
          </div>
        </div>
      </div>

      <!-- Cash: already collected (Paid) or to be collected later (Waiting for Payment) -->
      <div class="row" *ngIf="paymentMethod === 'cash'">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">PAYMENT STATUS</label>

          <div class="form-check">
            <input type="radio" id="flexCashPaid" name="cashPaymentStatus" class="form-check-input"
                   [(ngModel)]="cashPaymentStatus" value="Paid" />
            <label class="form-check-label" for="flexCashPaid">
              <strong style="font-size:12px;">Paid</strong><br />
              <small>Cash already collected. Booking is confirmed.</small>
            </label>
          </div>

          <div class="form-check mt-2">
            <input type="radio" id="flexCashWaiting" name="cashPaymentStatus" class="form-check-input"
                   [(ngModel)]="cashPaymentStatus" value="WaitingForPayment" />
            <label class="form-check-label" for="flexCashWaiting">
              <strong style="font-size:12px;">Waiting for Payment</strong><br />
              <small>Booking is blocked. Mark as paid once the cash is collected.</small>
            </label>
          </div>
        </div>
      </div>

      <!-- Pay Now: the customer pays online right away through BillDesk -->
      <div class="row" *ngIf="paymentMethod === 'payNow'">
        <div class="col-md-6 col-sm-12 form-group">
          <div class="total-amt">Amount = ₹{{ bookingData.amount | number:'1.0-2' }}</div>
          <div class="total-amt">Platform Fee = ₹{{ getFlexiblePlatformFee() | number:'1.0-2' }}</div>
          <div class="total-amt"><strong>Payable Now = ₹{{ getFlexiblePayableTotal() | number:'1.0-2' }}</strong></div>
        </div>
      </div>

      <div class="row" *ngIf="paymentMethod === 'sendLink'">
        <div class="col-md-6 col-sm-12 form-group">
          <label class="fieldName">PAYMENT OPTION</label>

          <div class="form-check">
            <input
              type="radio"
              id="adminPayAnytime"
              name="paymentOption"
              class="form-check-input"
              [(ngModel)]="paymentOption"
              value="anytime"
              required
            />
            <label class="form-check-label" for="adminPayAnytime">
              <strong style="font-size:12px;">Pay Anytime</strong><br />
              <!--<small>Slot will not be released till payment is successful or booking is cancelled.</small>-->
            </label>
          </div>

          <div class="form-check mt-2">
            <input
              type="radio"
              id="adminPayWithin"
              name="paymentOption"
              class="form-check-input"
              [(ngModel)]="paymentOption"
              value="within"
              required
            />
            <label class="form-check-label" for="adminPayWithin">
              <strong style="font-size:12px;" >Pay Within Time Limit</strong><br />
              <!--<small>Slot will be released after expiry.</small>-->
            </label>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="paymentMethod === 'sendLink' && paymentOption === 'within'">
        <div class="col-md-3 col-sm-12 form-group">
          <label class="fieldName" for="adminExpiryInDays">DURATION (IN DAYS)</label>
          <input
            id="adminExpiryInDays"
            type="number"
            name="expiryInDays"
            [(ngModel)]="expiryInDays"
            #expiryDaysCtrl="ngModel"
            [required]="paymentMethod === 'sendLink' && paymentOption === 'within'"
            [min]="0"
            [max]="30"
            class="form-control"
          />
          <div *ngIf="expiryDaysCtrl.touched && expiryDaysCtrl.invalid" class="text-danger">
            <div *ngIf="expiryDaysCtrl.errors?.['required']">Duration is required when payment link is selected.</div>
            <div *ngIf="expiryDaysCtrl.errors?.['min']">Duration must be valid.</div>
            <div *ngIf="expiryDaysCtrl.errors?.['max']">Duration cannot exceed 30 days.</div>
          </div>
        </div>

        <div class="col-md-3 col-sm-12 form-group">
          <label class="fieldName" for="adminExpiryInMin">DURATION (IN MIN)</label>
          <input
            id="adminExpiryInMin"
            type="number"
            name="expiryInMin"
            [(ngModel)]="expiryInMin"
            #expiryMinCtrl="ngModel"
            [required]="paymentMethod === 'sendLink' && paymentOption === 'within'"
            [min]="10"
            [max]="1439"
            class="form-control"
          />
          <div *ngIf="expiryMinCtrl.touched && expiryMinCtrl.invalid" class="text-danger">
            <div *ngIf="expiryMinCtrl.errors?.['required']">Duration is required when payment link is selected.</div>
            <div *ngIf="expiryMinCtrl.errors?.['min']">Duration must be at least 10 minutes.</div>
            <div *ngIf="expiryMinCtrl.errors?.['max']">Duration cannot exceed 1439 minutes (23h 59m).</div>
          </div>
        </div>
      </div>

      <!-- Row 9: Submit Button -->
      <div class="row">
        <div class="col-md-6 col-sm-12 form-group">
          <button class="btn btn-primary book-now-btn" type="submit" [disabled]="formRef.invalid || bookNowDisabled">Book Now</button>
          <button class="btn btn-secondary pop-up-btn-white" style = "margin-left:20px;" type="button" (click)="cancelFlexibleBooking()">Cancel</button>
        </div>
      </div>

    </form>
  </div>

  <div *ngIf="showGroupVenueLayout && selectedDate && selectedProduct && venuesForSelectedProduct.length > 0 && selectedServiceType !== 'Multi Session'"
  class="slotGrid">
  <app-group-by-venue-booking-slots [showFullDay]="showFullDay" [selectedDate]="selectedDate"
    [venues]="venuesForSelectedProduct" [selectedProduct]="selectedProduct"></app-group-by-venue-booking-slots>
</div>
</ng-container>
</div>

<div id="snackbar">Slot cancelled successfully.</div>
